import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { LEVEL_PUBLISHED, PARAM_CLIENTS_PATH, PARAM_PAGES_PATH, STATE_PAGES_PUBLISHED, STATE_PUBLISHED } from 'src/app/constants/constants';
import { Clients } from 'src/app/models/clients';
import { environment } from 'src/environments/environment';
import { Page } from 'src/app/cmspage/page';
import { Pages } from 'src/app/models/pages';
import { AbstractListController } from '../../common/abstract-list.component';
import { PagesService } from 'src/app/services/pages.service';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { FormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { ButtonDirective } from 'primeng/button';

import { TableModule } from 'primeng/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';

import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-manage-pages',
    templateUrl: './manage-pages.component.html',
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, Select, ButtonDirective, RouterLink, TableModule, NgxPaginationModule, ConfirmDialog, Toast]
})
export class ManagePagesComponent extends AbstractListController<Pages, any> {
  protected pagesService: PagesService;
  protected confirmationService: ConfirmationService;

  title = 'Pages';
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);
  client: Clients;
  readonly roomDialog = signal<boolean>(false);
  readonly filterSidebar = signal<boolean>(undefined);
  readonly imageUrl = signal<string>(undefined);
  readonly statePublished = signal<any[]>(undefined);
  readonly levelPublished = signal<any[]>(undefined);
  pages: Pages[];

  constructor() {
    const pagesService = inject(PagesService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(pagesService, confirmationService, router, route, PARAM_PAGES_PATH);
    this.pagesService = pagesService;
    this.confirmationService = confirmationService;

    this.cols.set([
      { field: "title", header: "Titolo" },
      { field: "is_active", header: "Attivo" },
      { field: "is_featured", header: "Featured" },
    ]);
    this.colsFilter.set([
      { field: "title", icon: "pi-file", header: "Titolo", type: "string" },
    ]);

    this.imageUrl.set(environment.imageUrl);

    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({ label: this.cols()[i].header, value: this.cols()[i] }); return [...a]; });
    }
    this.statePublished.set(STATE_PAGES_PUBLISHED);
    this.levelPublished.set(LEVEL_PUBLISHED);

  }




}

